import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as MaterialCategoryId } from '../../../../whole-house/material-category/Id';
import { Id as MaterialTemplateId } from '../../../../whole-house/material-template/Id';
import { PriceUnitItem } from '../../../../whole-house/material/price-unit';
import { Id as PropertyType, PropertyItem } from '../../../../whole-house/material/property-type';
import { Id as StockStatus } from '../../../../whole-house/material/stock-status';

export const Request = intersect(
	struct({
		name: iotsUtils.NotEmptyString,
		// sku: iotsUtils.NotEmptyString, // DO NOT ALLOW AN EDIT OF SKU
		priceUnit: PriceUnitItem,
		stockStatus: StockStatus,
		propertyTypes: array(PropertyType),
		// if propertyType has value then those proerties in propertyValues are required
		propertyValues: PropertyItem,
	})
)(
	partial({
		sku: iotsUtils.NotEmptyString, // TMP: allow sku to be updated

		materialCategoryId: MaterialCategoryId,
		newCategory: string,
		materialTemplateId: MaterialTemplateId,
	})
);
